import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as CoreActions from '../actions/coreActions';
import LeftNav from '../components/leftNav';
import ScrollToTop from '../../util/scrollToTop';


class App extends React.Component {
	constructor(props) {
		super(props);

		this.state = { showTranslator: false };

		this.toggleTranslator = this.toggleTranslator.bind(this);
	}

	toggleTranslator() {
		this.setState({ showTranslator: !this.state.showTranslator });
	}

	render() {
		return (
			<ScrollToTop>
				<div>
					{this.props.auth.loggedIn && <LeftNav className={this.state.showTranslator ? "m-t-40" : ""} />}

					<button className={"btn btn-grey translate" + (this.state.showTranslator ? " active" : "")} onClick={this.toggleTranslator}>
						<i className="translate-icon" />
					</button>

					<div className={"navbar navbar-default navbar-fixed-top translate-bar" + (this.state.showTranslator ? "" : " invisible")}>
						<div className="container text-center">
							<div id="google_translate_element" />
						</div>
					</div>

					<div className={"container" + (this.state.showTranslator ? " with-translate-bar" : " without-translate-bar")}>
						{this.props.children}
					</div>
				</div>
			</ScrollToTop>
		);
	}
}

App.propTypes = {
	children: PropTypes.element
};

function mapStateToProps(state) {
	return {
		booking: state.booking,
		core: state.core,
		auth: state.auth,
		uiState: state.core.uiState
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(CoreActions, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// ./app/core/containers/app.js